const REPORT_PERIODS = {
  ALTRIA: '2018-06-02',
  RJR: '2018-11-11'
};

export default REPORT_PERIODS;
